import { render, staticRenderFns } from "./UserZoneAdmin.vue?vue&type=template&id=0ef69956&lang=html&"
import script from "./UserZoneAdmin.vue?vue&type=script&lang=js&"
export * from "./UserZoneAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports